import { MultiFactorSelectorForm, PageHeader } from 'components'
import useQueryParam from 'core/hooks/useQueryParam'
import { useLocation, useNavigate } from 'react-router-dom'
import { IPageProps } from 'types'

interface IQueryParams {
    url?: string
}

const MultiFactorPage = ({ title }: IPageProps) => {
    const { url } = useQueryParam<IQueryParams>()
    const navigate = useNavigate()
    const location = useLocation()
    const message = location.state?.message

    const confirm = () => {
        //go to the page the user was headed to after confirming 2fa
        let confirmUrl = location.state?.confirmUrl ?? url ?? '/'
        if (confirmUrl.startsWith('http')) {
            window.location.href = confirmUrl
        }
        else
            navigate(confirmUrl)
    }

    const cancel = () => {
        //user cancelled so to the previous page before they tried to access 2fa data typically PII
        let cancelUrl: string = location.state?.cancelUrl
        if (cancelUrl.startsWith('http')) {
            window.location.href = cancelUrl
        }
        else
            navigate(cancelUrl)
    }

    return (
        <div className='mb-4'>
            <PageHeader title={title} />
            <MultiFactorSelectorForm
                onVerified={confirm}
                onSetup={confirm}
                onCancel={location.state?.cancelUrl ? cancel : undefined}
                message={message}
            />
        </div>
    )
}
export default MultiFactorPage